import { render } from "./LogoutView.vue?vue&type=template&id=f77d57b6&scoped=true&lang=html"
import script from "./LogoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutView.vue?vue&type=script&setup=true&lang=js"

import "./LogoutView.vue?vue&type=style&index=0&id=f77d57b6&lang=css&scoped=true"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77d57b6"]])

export default __exports__